import React from 'react'
import "./Core_benefits_card.css"

function Core_benefits_card({ text, imgSrc }) {
    return (
        <>
            <section className='Core_benefits_card'>
                <div className="icon_holder">
                    <img src={imgSrc} alt="benefits icon" className='Core_benefits_icon' />
                </div>

                <div className="text_holder">
                    <p>{text}</p>
                </div>
            </section>
        </>
    )
}

export default Core_benefits_card